var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"title":"Crear plantilla"}},[_c('formulario',{attrs:{"plantilla-contrato":_vm.plantillaContrato,"unidades-negocio-id":_vm.unidadesNegocioId},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }